const TeachersCardDic = {
    'comment': {
        'fa': 'نظر',
        'en': 'Comment'
    },
    'SessionCount': {
        'fa': 'کلاس',
        'en': 'Session'
    },
    'teacher': {
        'fa': 'مدرس',
        'en': 'Teacher'
    },
    'skill': {
        'fa': 'مهارت',
        'en': 'Skill'
    },
    'minPrice': {
        'fa': 'شروع قیمت از ساعتی',
        'en': 'Starting price from'
    }
    ,
    'category': {
        'fa': 'دسته بندی',
        'en': 'Category'
    }
    ,
    'tryOutClass': {
        'fa': 'کلاس آزمایشی',
    }
}
export default TeachersCardDic